import React from "react";
import "./CustomInput.scss"
import user from "../../assets/profile-2.svg"
import mail from "../../assets/mail.svg"
import address from "../../assets/location-black.svg"
import suitecase from "../../assets/suitcase.svg"



const CustomTextArea2 = ({ label, icon, value, onChange, placeholder, required, error, errorText, disable }) => {
    const getIcons = () => {
        const icons = {
            user: user,
            email: mail,
            address: address,
            work: suitecase
        };

        return icons[icon] || user;
    };

    return (
        <div className="CustomInput">
            <div className="input-label">
                {required && <span className="input-req">* </span>}
                {label}
            </div>
            <div className={`CustomInput-container-textarea  ${error ? "error" : disable ? "disable" : ""}`}>
                {icon && <img className="CustomInput-container-textarea-icon" alt="" src={getIcons()} />}
                <textarea
                    className="CustomInput-container-textarea-wrapper"
                    value={value}
                    onChange={onChange}
                    type="text"
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default CustomTextArea2